// @ts-nocheck

import { request } from '../../../../../context';
import type { ApiOptions } from '../../../../../context';
import type {
    PostIntelligentPartnerHomePageStudentPictureAbilityBody,
    BaseResponseListIntelligentPartnerHomePageStudentPictureAbilityResponse,
} from '../../../../../types';

/**
 * 员工画像-能力成长趋势
 *
 * @export
 * @tags 智能陪练首页接口
 * @link [POST] /intelligentPartner/homePage/student/picture/ability
 */
export function postIntelligentPartnerHomePageStudentPictureAbility(
    data: PostIntelligentPartnerHomePageStudentPictureAbilityBody
): Promise<BaseResponseListIntelligentPartnerHomePageStudentPictureAbilityResponse>;
export function postIntelligentPartnerHomePageStudentPictureAbility(
    data: PostIntelligentPartnerHomePageStudentPictureAbilityBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseListIntelligentPartnerHomePageStudentPictureAbilityResponse>;
export function postIntelligentPartnerHomePageStudentPictureAbility(
    data: PostIntelligentPartnerHomePageStudentPictureAbilityBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseListIntelligentPartnerHomePageStudentPictureAbilityResponse> {
    return request<PostIntelligentPartnerHomePageStudentPictureAbilityBody, never, never>(
        '/intelligentPartner/homePage/student/picture/ability',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postIntelligentPartnerHomePageStudentPictureAbility',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练首页接口'],
        path: '/intelligentPartner/homePage/student/picture/ability',
        method: 'post',
    },
];
